import React, { Fragment } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

interface PrivateRoute {
  component: any;
  path: string;
  exact?: boolean;
}

const PrivateRoute: React.FC<PrivateRoute> = ({
  component: Component,
  ...rest
}) => {
  const { isAuthenticated, isLoading } = useAuth0();

  return (
    <Route
      {...rest}
      render={(props) => {
        // Show loading state
        if (isLoading) {
          return null; // Or return a loading component
        }

        return isAuthenticated ? (
          <Fragment>
            <Component {...props} />
          </Fragment>
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
};

export default PrivateRoute;
